import React, { Component } from "react";
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux';
import { GeneralAlert } from '../../components/Alert/Alert';
import { renderLegacyTextField, LegacyRenderSelectV2, renderTextFieldWithChips } from '../../utils/engageComponents'

import Grid from '@material-ui/core/Grid';

import Modal from '@material-ui/core/Modal'

import {
    GetDevice,
    UpdDevice,
    AddMessage,
    UnregisterResidents,
    GetDevicesLocations,
    GetDevicesResidents,
    GetDevicesSerials,
    AddMessageChangeStatus
} from '../../actions/deviceActions';
import { getResidentsByCommunity } from '../../actions/residentActions';


//FontAwesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faClipboardList,
    faGlobe
} from "@fortawesome/free-solid-svg-icons";

import { currentScrollingPage } from "../../constants/index";

import LModalUnregister from './LModalUnregister';
import LModalMessage from './LModalMessage';
import LModalReboot from './LModalReboot';

import { ADD_MESSAGE_FILTERS_SUCCESS, ADD_MESSAGE_SUCCESS } from "../../constants/devicesConstants";

//3 party Libs
import moment from 'moment';

export class ManagementDeviceDetails extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModalUntegister: false,
            showModalMessage: false,
            showModalReboot: false,
            isUpdDevice: false,
            selectedDevices: [],
            devices: props.tableData ? props.tableData : [],
            deviceSelected: props.deviceSelected,
            residentDetailSelected: undefined,
            chipsArray: (props.deviceSelected && props.deviceSelected.tags) ? props.deviceSelected.tags : [],
            currentPage: currentScrollingPage,
            filterObj: undefined,
            //Sorting
            sortColumn: 'lowerName',
            sortDesc: true
        };

        if (props.deviceSelected) {
            this.props.dispatch(change('ManagementDeviceDetails', '_id', props.deviceSelected._id));
            this.props.dispatch(change('ManagementDeviceDetails', 'serial', props.deviceSelected.serial));
            this.props.dispatch(change('ManagementDeviceDetails', 'docsis', props.deviceSelected.docsis));
            this.props.dispatch(change('ManagementDeviceDetails', 'ethernet', props.deviceSelected.ethernet));
            this.props.dispatch(change('ManagementDeviceDetails', 'wifiMac', props.deviceSelected.wifiMac));
            this.props.dispatch(change('ManagementDeviceDetails', 'ssidWifi', props.deviceSelected.ssidWifi));
            this.props.dispatch(change('ManagementDeviceDetails', 'ip', props.deviceSelected.ip));
            this.props.dispatch(change('ManagementDeviceDetails', 'Location', props.deviceSelected.residentLocation));
        } else {
            this.props.dispatch(change('ManagementDeviceDetails', 'serial', ''));
            this.props.dispatch(change('ManagementDeviceDetails', 'docsis', ''));
            this.props.dispatch(change('ManagementDeviceDetails', 'ethernet', ''));
            this.props.dispatch(change('ManagementDeviceDetails', 'wifiMac', ''));
            this.props.dispatch(change('ManagementDeviceDetails', 'ssidWifi', ''));
            this.props.dispatch(change('ManagementDeviceDetails', 'ip', ''));
        }


    }

    componentDidMount() {
        this.props.getResidentsByCommunity(this.props.communityInfo._id);
    }

    OnCancelHandler = () => {
        this.setState({ showModalUntegister: false, showModalMessage: false, showModalReboot: false });
    };

    OnUnregisterHandler = () => {
        const newMessage = {}
        newMessage.notificationType = "Full"
        newMessage.notificationType = "Unregistration"
        newMessage.messageType = "Normal"

        newMessage.topics = [];

        const device = this.props.deviceSelected;

        newMessage.topics.push(`${device.residentId}/${device._id}`);

        let messageDate = moment(new Date());

        newMessage.messageDate = messageDate;
        const stylesObj = { modalStyles: { backgroundColor: '#ffffff' }, messageClass: 'LAlertMessageStyles' };
        this.props.UnregisterResidents([device], localStorage.getItem('communityId'), newMessage, stylesObj);

        this.setState({ showModalUntegister: false, selectedDevices: [] }, () => {
            this.props.onCloseDetials();
        });
    };

    //#region  Inner Components -Get status icons
    GetStatusIcons = ({ active = false, lastConnectionDate = undefined }) => {

        const now = new Date();
        const lastConn = lastConnectionDate ? new Date(lastConnectionDate) : undefined;

        const umbralInMinutes = this.props.umbralInMinutes ? this.props.umbralInMinutes : 5;
        let lastConnectionWithinUmbral = false;

        if (!lastConn || isNaN(lastConn.getTime())) {
            lastConnectionWithinUmbral = false;
        } else {
            lastConnectionWithinUmbral = (umbralInMinutes * 60 * 1000) > (now.getTime() - lastConn.getTime());
        }

        return (
            <Grid item container justify='center' alignContent='center'>
                <Grid item style={{ margin: '0 5px', marginRight: '35px' }}>
                    <FontAwesomeIcon
                        className="icon-menu-size"
                        icon={faClipboardList}
                        style={{ color: active ? '#5BDB86' : '#959494' }}
                    />
                </Grid>
                <Grid item style={{ margin: '0 5px' }}>
                    <FontAwesomeIcon
                        className="icon-menu-size"
                        icon={faGlobe}
                        style={{ color: lastConnectionWithinUmbral ? '#5BDB86' : '#959494' }}
                    />
                </Grid>
            </Grid>
        );
    }
    //#endregion


    //#region Chips

    handlerOnChipDelete = (chipText) => {
        let newChipArray = this.state.chipsArray;
        const index = newChipArray.indexOf(chipText);

        if (index !== -1) {
            newChipArray.splice(index, 1);
            this.setState({ chipsArray: newChipArray })
        }

    };
    handleOnchangeTextField = (newText) => {
        this.setState({ textFieldActualText: newText });
    };
    handleOnClickAddButton = () => {
        const textNewChip = this.state.textFieldActualText;
        const index = this.state.chipsArray.indexOf(textNewChip);
        let chips = this.state.chipsArray;

        if (chips.length < 10) {
            if (textNewChip.length <= 25) {
                if (index === -1 && textNewChip.length > 0) {
                    chips.push(textNewChip)
                    this.setState({ chipsArray: chips })
                }
            } else {
                const message = 'The identifier should contain less than 25 characters';
                GeneralAlert('error', message);
            }
        } else {
            const message = 'Can´t add more than 10 identifiers per device';
            GeneralAlert('error', message);
        }
        this.props.dispatch(change('DeviceForm', 'DeviceTags', ''));
    };

    //#endregion Chips

    handleDeleteClick = async (e, data, index) => {
        if (e) {
            e.stopPropagation();
        }
    };

    async onSubmitHandler(formData) {
        if (formData._id) {
            let data = formData;
            const residentSelected = this.state.residentDetailSelected;
            data.residentId = residentSelected._id;
            data.residentName = residentSelected.firstName + ' ' + residentSelected.lastName;
            data.residentLocation = residentSelected.zoneName;
            data.residentPictureUrl = residentSelected.pictureUrl;
            data.tags = this.state.chipsArray;

            const stylesObj = { modalStyles: { backgroundColor: '#ffffff' }, messageClass: 'LAlertMessageStyles' };
            this.props.UpdDevice(formData._id, data, localStorage.getItem('communityId'), stylesObj);
        }
    };

    render() {

        if (this.props.residentData.length > 0 & this.state.residentDetailSelected === undefined) {
            this.setState({ residentDetailSelected: this.props.residentData.find(res => res._id === this.props.deviceSelected.residentId) })
        }

        if ((this.props.deviceReducerType === ADD_MESSAGE_FILTERS_SUCCESS || this.props.deviceReducerType === ADD_MESSAGE_SUCCESS) && (this.state.showModalReboot || this.state.showModalMessage)) {
            this.OnCancelHandler();
            this.props.AddMessageChangeStatus();
        }
        return (
            <>
                <div className="activityTitle-engage" style={{ padding: "24px" }}>
                    <form >
                        <div id="save_device_Btn" style={{ display: 'none' }}
                            onClick={this.props.handleSubmit(this.onSubmitHandler.bind(this))}>
                            Save
                        </div>
                        <div id="Message_Device_Btn" style={{ display: 'none' }}
                            onClick={() => (this.setState({ showModalMessage: true }))
                            }>
                            Message
                        </div>
                        <div id="Reboot_Device_Btn" style={{ display: 'none' }}
                            onClick={() => (this.setState({ showModalReboot: true }))
                            }>
                            Reboot
                        </div>
                        <div id="Unregister_Device_Btn" style={{ display: 'none' }}
                            onClick={() => {
                                this.setState({ showModalUntegister: true })
                            }}>
                            Unregister
                        </div>

                        {
                            //Device Edit Form
                            <React.Fragment>
                                <Grid container xs={12} spacing={5} style={{ marginTop: '30px' }} direction='row' alignItems='flex-start' justify='space-between'>
                                    <Grid item container direction='column' xs={4}>
                                        <Grid item className='LSectionTitle' >General</Grid>
                                        <Grid id='device_addedit_general' item container xs={12} className=' LGridColumn' >
                                            <Grid item xs={12} className='LSectionContent' style={{ padding: '10px' }} >
                                                <Field
                                                    id='device_addedit_general_serial'
                                                    name="serial"
                                                    label="Serial Number"
                                                    value={(this.state.deviceSelected) ? this.state.deviceSelected.serial : ''}
                                                    inputClass='setupInfoSection'
                                                    component={renderLegacyTextField}
                                                />
                                            </Grid>
                                            <Grid item xs={12} className='LSectionContent' style={{ padding: '10px' }}>
                                                <Field
                                                    id='device_addedit_general_docsis'
                                                    name="docsis"
                                                    label="DOCSIS MAC"
                                                    value={(this.state.deviceSelected.docsis) ? this.state.deviceSelected.docsis : ''}
                                                    className='textField'
                                                    inputClass='setupInfoSection'
                                                    component={renderLegacyTextField}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid item className='LSectionTitle' style={{ marginTop: '30px', textAlign: 'left' }}>Network</Grid>
                                        <Grid id='device_addedit_network' item container xs={12} className=' LGridColumn'>
                                            <Grid item xs={12} className='LSectionContent' style={{ padding: '10px' }}>
                                                <Field
                                                    id='device_addedit_network_ethernet'
                                                    name="ethernet"
                                                    label="Ethernet MAC"
                                                    value={(this.state.deviceSelected.ethernet) ? this.state.deviceSelected.ethernet : ''}
                                                    className='textField'
                                                    inputClass='setupInfoSection'
                                                    component={renderLegacyTextField}
                                                />
                                            </Grid>
                                            <Grid item xs={12} className='LSectionContent' style={{ padding: '10px' }}>
                                                <Field
                                                    id='device_addedit_network_wifimac'
                                                    name="wifiMac"
                                                    label="WiFi MAC"
                                                    value={(this.state.deviceSelected.wifiMac) ? this.state.deviceSelected.wifiMac : ''}
                                                    className='textField'
                                                    inputClass='setupInfoSection'
                                                    component={renderLegacyTextField}
                                                />
                                            </Grid>
                                            <Grid item xs={12} className='LSectionContent' style={{ padding: '10px' }}>
                                                <Field
                                                    id='device_addedit_network_ssidwifi'
                                                    name="ssidWifi"
                                                    label="SSID WiFi"
                                                    value={(this.state.deviceSelected.ssidWifi) ? this.state.deviceSelected.ssidWifi : ''}
                                                    className='textField'
                                                    inputClass='setupInfoSection'
                                                    component={renderLegacyTextField}

                                                />
                                            </Grid>
                                            <Grid item xs={12} className='LSectionContent' style={{ padding: '10px' }}>
                                                <Field
                                                    id='device_addedit_network_ipaddress'
                                                    name="ip"
                                                    label="IP Address"
                                                    value={(this.state.deviceSelected.ip) ? this.state.deviceSelected.ip : ''}
                                                    className='textField'
                                                    inputClass='setupInfoSection'
                                                    component={renderLegacyTextField}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction='column' xs={4}>
                                        <Grid item className='LSectionTitle'  >Registree</Grid>
                                        <Grid id='device_addedit_registree' item container xs={12} className=' LGridColumn'>
                                            <Grid item xs={12} className='LSectionContent' style={{ padding: '10px' }}>
                                                <Field
                                                    showStartAdornment={true}
                                                    name="SelectResident"
                                                    disabled={false}
                                                    maxLength={20}
                                                    selected={this.state.residentDetailSelected ? this.state.residentDetailSelected : {}}
                                                    optionsItemsIconsData={this.props.residentData ? this.props.residentData : []}
                                                    onChangeHandler={
                                                        (evet, newItem) => {
                                                            if (newItem !== null && newItem !== '') {
                                                                let deviceSelected = this.state.deviceSelected;
                                                                deviceSelected.residentId = newItem._id;
                                                                deviceSelected.residentLocation = newItem.zoneName;
                                                                deviceSelected.residentName = `${newItem.firstName} ${newItem.lastName}`;
                                                                deviceSelected.residentPictureUrl = newItem.pictureUrl;

                                                                this.props.dispatch(change('ManagementDeviceDetails', 'Location', newItem.zoneName));

                                                                this.setState({
                                                                    deviceSelected: deviceSelected,
                                                                    residentDetailSelected: newItem
                                                                });

                                                            } else {
                                                                this.setState({ residentDetailSelected: undefined });
                                                            }
                                                        }
                                                    }
                                                    component={LegacyRenderSelectV2}
                                                    diableClear={true}
                                                    idToSet="legacy_Settings_renderSelect"
                                                    id='legacy_Settings_renderSelect'
                                                />
                                            </Grid>
                                            <Grid item xs={12} className='LSectionContent' style={{ display: 'grid', padding: '10px' }}>
                                                <Field
                                                    id='device_addedit_registree_location'
                                                    name='Location'
                                                    label={'Location'}
                                                    placeholder={'Location'}
                                                    value={this.state.deviceSelected.residentLocation ? this.state.deviceSelected.residentLocation : ""}
                                                    className='textField'
                                                    inputClass='setupInfoSection'
                                                    component={renderLegacyTextField}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction='column' xs={4}>
                                        <Grid item className='LSectionTitle' >Identifiers</Grid>
                                        <Grid id='device_addedit_registree_identifiers' item container xs={12} className=' LGridColumn'>
                                            <Grid item xs={12} style={{ padding: '10px', color: 'black' }}>
                                                <Field
                                                    idToSet='Ldevice_addedit_registree_tags'
                                                    name="DeviceTags"
                                                    label="Tags"
                                                    value={this.state.textFieldActualText}
                                                    maxLength={20}
                                                    chipsOptions={this.state.chipsArray}
                                                    handlerOnChipDelete={(chipText) => this.handlerOnChipDelete(chipText)}
                                                    handlerOnClickAddButton={() => { this.setState({ textFieldActualText: '' }); this.handleOnClickAddButton(); }}
                                                    onChange={(e) => { this.handleOnchangeTextField(e.target.value) }}
                                                    onKeyDown={e => { if (e && e.keyCode && e.keyCode === 13) { this.setState({ textFieldActualText: '' }); this.handleOnClickAddButton(); } }}
                                                    component={renderTextFieldWithChips}
                                                    inputClass='LChipsField'
                                                    disabled={false}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </React.Fragment>
                        }


                        {/* REGISTER & UNREGISTER MODAL */}
                        <Modal
                            open={this.state.showModalUntegister}
                            onClose={() => this.setState({ showModalUntegister: false })}
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            style={{ borderRadius: '16px' }}
                        >
                            <LModalUnregister
                                OnCancelHandler={this.OnCancelHandler}
                                OnUnregisterHandler={this.OnUnregisterHandler}
                                isRegister={false}
                                selectedDevices={[this.props.deviceSelected]}
                                selectAllButton={false}
                                filterObj={undefined}
                                sortColumn={'lowerName'}
                                sortDesc={true}
                            />
                        </Modal>

                        {/* MESSAGE MODAL */}
                        <Modal
                            open={this.state.showModalMessage}
                            onClose={() => this.setState({ showModalMessage: false })}
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            style={{ borderRadius: '16px' }}
                        >
                            <LModalMessage
                                OnCancelHandler={this.OnCancelHandler}
                                isRegister={false}
                                selectedDevices={[this.props.deviceSelected]}
                                selectAllButton={false}
                                filterObj={undefined}
                                sortColumn={'lowerName'}
                                sortDesc={true}
                            />
                        </Modal>

                        {/* REBOOT MODAL */}
                        <Modal
                            open={this.state.showModalReboot}
                            onClose={() => this.setState({ showModalReboot: false })}
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            style={{ borderRadius: '16px' }}
                        >
                            <LModalReboot
                                OnCancelHandler={this.OnCancelHandler}
                                isRegister={false}
                                selectedDevices={[this.props.deviceSelected]}
                                selectAllButton={false}
                                filterObj={undefined}
                                sortColumn={'lowerName'}
                                sortDesc={true}
                            />
                        </Modal>
                    </form>
                </div>
            </>
        )
    }

}

function mapStateToProps(state) {

    const deviceData = (state.deviceReducer && state.deviceReducer.deviceData) ? [...state.deviceReducer.deviceData] : [];
    let residentData = (state.residentReducer && state.residentReducer.residentData) ? state.residentReducer.residentData : [];
    const total = (state.deviceReducer && state.deviceReducer.totalDevices) ? state.deviceReducer.totalDevices : 0;

    if (residentData && Array.isArray(residentData)) {
        residentData = residentData.map(item => {
            return {
                ...item,
                name: `${item.firstName} ${item.lastName}`
            }
        })
    }

    return {
        tableData: deviceData,
        residentData: residentData,
        total,
        deviceReducerType: (state.deviceReducer && state.deviceReducer.type) ? state.deviceReducer.type : ""
    }
}


export default connect(mapStateToProps, { GetDevice, UpdDevice, AddMessage, UnregisterResidents, GetDevicesLocations, GetDevicesResidents, GetDevicesSerials, getResidentsByCommunity, AddMessageChangeStatus })(reduxForm({
    form: 'ManagementDeviceDetails',
    enableReinitialize: true
})(ManagementDeviceDetails));